<template>
    <app-layout>
        <template #header>
            <div v-if="$page.props.labels['documents.title'] || $page.props.labels['documents.text']" class="text-center">
                <h2 class="text-2xl text-black leading-tight mb-2" v-if="$page.props.labels['documents.title']">{{$page.props.labels['documents.title']}}</h2>
                <p class="text-base font-serif" v-if="$page.props.labels['documents.text']">{{$page.props.labels['documents.text']}}</p>
            </div>
        </template>

        <tabs :tabList="categories">
          <template v-for="(documents, category) in $page.props.documents" :key="category" v-slot:[getTabPanelSlotName(category)]>
            <div class="py-12 px-4 md:px-0 max-w-3xl mx-auto">
              <div class="max-w-md mx-auto sm:px-6 lg:px-8">
                <a
                  v-for="(document, key) in documents"
                  :key="document.id"
                  :href="document.file"
                  download
                  class="group block py-4 -ml-4 -mr-4 px-4 border-b transition-all hover:border-transparent hover:shadow-xl focus:shadow-lg"
                  :class="{ 'border-t': key === 0 }">
                    <div class="text-lg mb-2">
                        {{ document.name }}
                    </div>
                    <div class="flex relative">
                        <p class="text-gray-500 text-sm leading-7">
                            {{ document.original_filename }} ({{ bytesToSize(document.size) }})<br>
                            Erstellt: {{ document.created_at_formatted }}
                        </p>
                        <div class="absolute text-gray-500 right-0 bottom-2 opacity-0 group-hover:opacity-1 group-hover:bottom-0 animate-bounce cursor-pointer w-9 h-9 p-1 mr-2 transition-all">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                        </div>
                    </div>
                </a>
              </div>
            </div>
          </template>
        </tabs>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import Welcome from '@/Jetstream/Welcome'

    import Tabs from '@/Components/Tabs/Tabs.vue'

    export default {
        components: {
            AppLayout,
            Welcome,
            Tabs
        },

        computed: {
          categories() {
            return Object.keys(this.$page.props.documents)
          }
        },

        methods: {
            bytesToSize(bytes) {
                var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                if (bytes == 0) return '0 Byte';

                var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
            },

            getTabPanelSlotName(name) {
              return 'tabPanel-' + (this.categories.indexOf(name) + 1)
            }
        }
    }
</script>
